const styles = {
  root: {
    padding: '6px!important',
  },

}
export default styles
